import { MagnifyingGlass } from "@phosphor-icons/react"
import { colorsV4 } from "@tokenterminal/ui/theme/themeV4/colorsContract.css"
import { useEffect, useRef } from "react"
import { twMerge } from "tailwind-merge"
import { Icon } from "../../icon"
import { Slot } from "../../input/TextField"

const iconSizeLookup = {
  small: 12,
  medium: 14,
  large: 16,
}

const SearchInput = ({
  placeholder = "Search",
  icon = MagnifyingGlass,
  value,
  onChange,
  onKeyDown,
  innerRef,
  autoFocus = true,
  size = "medium",
  className,
  inputProps,
}: {
  placeholder?: string
  icon?: React.ElementType
  value?: string
  onChange?: (value: string) => void
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void
  innerRef?: React.RefObject<HTMLInputElement>
  autoFocus?: boolean
  size?: "small" | "medium" | "large"
  className?: string
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>
}) => {
  const _ref = useRef<HTMLInputElement>(null)
  const ref = innerRef ?? _ref

  useEffect(() => {
    if (ref.current && autoFocus) {
      ref.current.focus()
    }
  }, [ref, autoFocus])

  return (
    <div
      className={twMerge(
        "tt-input-container !flex-shrink-0 !w-full",
        className
      )}
      data-size={size}
    >
      {icon && (
        <Slot>
          <Icon
            as={icon}
            width={iconSizeLookup[size]}
            style={{
              color: colorsV4.fg.secondary,
            }}
          />
        </Slot>
      )}
      <input
        ref={ref}
        className="tt-input-base"
        placeholder={placeholder}
        onChange={(e) => {
          onChange?.(e.target.value)
        }}
        onKeyDown={onKeyDown}
        value={value}
        {...inputProps}
      />
    </div>
  )
}

export default SearchInput
